// extracted by mini-css-extract-plugin
export default {"presentation":"presentation_presentation__oOOSE","presentation_image":"presentation_presentation_image__mmNNU"};